<template>
    <div class="panel-card">
        <!-- 一级导航栏 -->
        <div class="news-top-tab-bar">
            <div class="news-left-tabs">
        <span
            v-for="tab in newsTopTabs"
            :key="tab.key"
            class="top-tab-item"
            :class="{active: currentTopTab === tab.key}"
            @click="setTopTab(tab.key)"
        >
          {{ tab.label }}
        </span>
            </div>
            <div class="news-right-more">
                <a class="text-link" @click="goMore">更多 ></a>
            </div>
        </div>
        <!-- 二级分类栏 -->
        <div class="news-sub-tab-bar">
      <span
          v-for="subTab in newsSubTabs"
          :key="subTab.key"
          class="sub-tab-item"
          :class="{active: currentSubTab === subTab.key}"
          @click="setSubTab(subTab.key)"
      >
        {{ subTab.label }}
      </span>
        </div>
        <!-- 举报方式 -->
        <div class="panel-body news-panel-body" v-if="isReportWay">
            <div class="report-way">
                <div class="report-title">来访地址</div>
                <div class="report-value">同仁街31号5层510室党群与纪监审计部</div>
                <div class="report-title">来信邮编</div>
                <div class="report-value">210008</div>
                <div class="report-title">举报电话</div>
                <div class="report-value">（025）83283646</div>
                <div class="report-title">举报邮箱</div>
                <div class="report-value">njlzyjx@bewg.net.cn</div>
            </div>
        </div>
        <!-- 新闻区域：顶部3张大图 + 下方列表 -->
        <div class="panel-body news-panel-body" v-else>
            <!-- 顶部三张彩色大图卡片 -->
            <div class="news-big-card-wrap" v-if="newsList.length > 0">
                <div
                    class="big-card-item"
                    v-for="(item, index) in newsList.slice(0,4)"
                    :key="item.id"
                    :style="{background: getBigCardBg(index)}"
                    @click="goDetail(item)"
                >
                    <img class="big-card-cover-img" :class="{'no-image': !item.face || failedImages.has(item.id)}" :src="item.face || '/noImage.png'" alt="" @error="e => handleImgError(e, item)" />
                    <div class="big-card-tag">{{ getType(item) }}</div>
                    <div class="big-card-title">{{ item.title }}</div>
                </div>
            </div>
            <!-- 下方新闻列表，跳过前4条 -->
            <a-list :data-source="newsList.slice(4)" class="news-list-wrap">
                <template slot="renderItem" slot-scope="item, index">
                    <a-list-item class="news-list-item" @click="goDetail(item)">
                        <span class="news-dot"></span>
                        <span class="news-title" :title="item.title">{{ item.title }}</span>
                        <span class="news-time">{{ getTime(item) }}</span>
                    </a-list-item>
                </template>
            </a-list>
            <div v-if="newsList.length === 0" class="news-empty">
                <a-empty />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { fetchList } from "@/api/document";
import { fetchList as fetchNotice } from "@/api/party";
import { fetchList as fetchStaffCultureList } from "@/api/oa/staffCulture";
import { fetchList as fetchStaffQualityList } from "@/api/oa/quality";

export default {
    name: 'CompanyNews',
    data() {
        return {
            currentTopTab: 'news',
            currentSubTab: 'all',
            newsList: [],
            failedImages: new Set(),
            colorList: ['#0c3a7a', '#178045', '#af6e09', '#5e2ab2', '#ff8686'],
            // 顶部4个大图渐变背景色，和截图一致：蓝、绿、橙、紫
            bigCardBgList: [
                'linear-gradient(135deg,#4080ee,#2047b8)',
                'linear-gradient(135deg,#36c78b,#08784f)',
                'linear-gradient(135deg,#ffbc42,#d86b00)',
                'linear-gradient(135deg,#9254de,#5e2ab2)'
            ]
        }
    },
    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        newsTopTabs() {
            return [
                { key: 'news', label: '公司新闻' },
                { key: 'party', label: '党群公告' },
                { key: 'compliance', label: '廉洁合规' },
                { key: 'staff', label: '员工天地' },
                { key: 'safety', label: '质量安全' }
            ]
        },
        categoryList() {
            return this.findDataDict("documentType.newsCenter") || [];
        },
        partyWorkType() {
            return this.findDataDict("partyWorkType") || [];
        },
        honestType() {
            return this.findDataDict("honestType") || [];
        },
        newsSubTabs() {
            const mapDict = dict => dict.map(item => ({ key: item.value, label: item.name }));
            if (this.currentTopTab === 'party') {
                return [{ key: 'all', label: '最新公告' }, ...mapDict(this.partyWorkType)];
            }
            if (this.currentTopTab === 'compliance') {
                return [
                    { key: 'all', label: '最新公告' },
                    ...mapDict(this.honestType),
                    { key: 'report', label: '举报方式' }
                ];
            }
            if (this.currentTopTab === 'staff') {
                return [{ key: 'all', label: '员工天地' }];
            }
            if (this.currentTopTab === 'safety') {
                return [{ key: 'all', label: '质量安全' }];
            }
            return [{ key: 'all', label: '全部' }, ...mapDict(this.categoryList)];
        },
        categoryMap() {
            const map = {};
            this.categoryList.forEach(item => {
                map[item.value] = item.name;
            });
            return map;
        },
        currentSubTabLabel() {
            const found = this.newsSubTabs.find(tab => tab.key === this.currentSubTab);
            return found ? found.label : '';
        },
        isReportWay() {
            return this.currentTopTab === 'compliance' && this.currentSubTab === 'report';
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        setTopTab(key) {
            if (this.currentTopTab === key) return;
            this.currentTopTab = key;
            this.currentSubTab = 'all';
            this.getList();
        },
        setSubTab(key) {
            if (this.currentSubTab === key) return;
            this.currentSubTab = key;
            this.getList();
        },
        getList() {
            const tab = this.currentTopTab;
            const sub = this.currentSubTab;
            const category = sub === 'all' ? undefined : sub;
            if (tab === 'news') {
                fetchList({ pageNum: 1, pageSize: 9, category }).then(res => {
                    if (res && Array.isArray(res.list)) {
                        this.newsList = res.list;
                    }
                });
            } else if (tab === 'party') {
                fetchNotice({
                    pageNum: 1,
                    pageSize: 7,
                    type: category,
                    category: 'partywork'
                }).then(res => {
                    if (res && Array.isArray(res.list)) {
                        this.newsList = res.list;
                    }
                });
            } else if (tab === 'compliance') {
                if (this.isReportWay) {
                    this.newsList = [];
                    return;
                }
                fetchNotice({
                    pageNum: 1,
                    pageSize: 7,
                    type: category,
                    category: 'discipline'
                }).then(res => {
                    if (res && Array.isArray(res.list)) {
                        this.newsList = res.list;
                    }
                });
            } else if (tab === 'staff') {
                fetchStaffCultureList({ pageNum: 1, pageSize: 5 }).then(res => {
                    if (res && Array.isArray(res.list)) {
                        this.newsList = res.list;
                    }
                });
            } else if (tab === 'safety') {
                fetchStaffQualityList({ pageNum: 1, pageSize: 5 }).then(res => {
                    if (res && Array.isArray(res.list)) {
                        this.newsList = res.list;
                    }
                });
            }
        },
        getColor(index) {
            return this.colorList[index % this.colorList.length];
        },
        handleImgError(e, item) {
            if (!e.target.src.endsWith('/noImage.png')) {
                this.failedImages.add(item.id);
                e.target.src = '/noImage.png';
            }
        },
        getBigCardBg(index) {
            return this.bigCardBgList[index % this.bigCardBgList.length];
        },
        getType(item) {
            if (this.currentTopTab === 'news' && item.category && this.categoryMap[item.category]) {
                return this.categoryMap[item.category];
            }
            return this.currentSubTabLabel;
        },
        getTime(item) {
            const date = this.currentTopTab === 'news' ? item.createAt : item.publishAt;
            return this.$getDateString(date);
        },
        goDetail(item) {
            const id = item.id;
            const routeMap = {
                news: `/document/detail?id=${id}`,
                party: `/party/public/notice/detail?id=${id}`,
                compliance: `/party/public/honest/detail?id=${id}`,
                staff: `/oa/staffCulture/detail?id=${id}`,
                safety: `/oa/quality/detail?id=${id}`
            };
            this.$router.push(routeMap[this.currentTopTab]);
        },
        goMore() {
            const routeMap = {
                news: '/document',
                party: '/party/public/notice',
                compliance: '/party/public/honest',
                staff: '/oa/staffCulture',
                safety: '/oa/quality'
            };
            this.$router.push(routeMap[this.currentTopTab]);
        }
    }
}
</script>

<style scoped>
.panel-card {
    background: #fff;
    border: 1px solid #eef0f3;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.panel-body {
    padding: 5px 18px;
}
.news-panel-body {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
}
.text-link {
    color: #2563eb;
    cursor: pointer;
    text-decoration: none;
}
.text-link:hover {
    color: #1d4ed8;
}

/* ========== 公司新闻顶部Tab ========== */
.news-top-tab-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 15px 8px;
    flex-shrink: 0;
}
.news-left-tabs {
    display: flex;
    gap: 10px;
}
.top-tab-item {
    font-size: 14px;
    color: #666;
    cursor: pointer;
    padding-bottom: 6px;
}
.top-tab-item.active {
    color: #d4380d;
    font-weight: bold;
    font-size: 16px;
}
.news-sub-tab-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 5px 15px 5px;
    border-top: 1px solid #f0f0f0;
    flex-shrink: 0;
}
.sub-tab-item {
    font-size: 12px;
    color: #666;
    cursor: pointer;
    padding-bottom: 4px;
}
.sub-tab-item.active {
    color: #2563eb;
    font-weight: bold;
    border-bottom: 2px solid #2563eb;
}
.news-panel-body {
    padding-top: 4px;
}

/* ========== 顶部大图卡片样式（2×2网格） ========== */
.news-big-card-wrap {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    margin-bottom: 16px;
}
.big-card-item {
    height: 155px;
    border-radius:12px;
    padding:16px;
    cursor:pointer;
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    position:relative;
    overflow:hidden;
}
.big-card-cover-img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
}
.big-card-cover-img.no-image {
    object-fit: contain;
    width: 60%;
    height: 60%;
    margin: auto;
    z-index: 0;
    opacity: 0.7;
}
.big-card-item::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(0,0,0,0.45), rgba(0,0,0,0.15));
    z-index: 1;
}
.big-card-item > .big-card-tag,
.big-card-item > .big-card-title {
    position: relative;
    z-index: 2;
}
.big-card-tag {
    background:rgba(255,255,255,0.25);
    color:#fff;
    width:fit-content;
    padding:3px 8px;
    border-radius:6px;
    font-size:12px;
}
.big-card-title {
    color:#fff;
    font-size:14px;
    font-weight:500;
    line-height:1.4;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
}

/* ========== 下方新闻列表样式 ========== */
::v-deep .news-list-wrap .ant-list-item {
    padding: 8px 0;
    border-bottom: none;
    cursor: pointer;
}
::v-deep .news-list-wrap .ant-list-item:hover {
    background-color: #f9f9f9;
}
.news-list-item {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
}
.news-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #2563eb;
    flex-shrink: 0;
}
.news-title {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    color: #5c5c5c;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.news-list-item:hover .news-title {
    color: #2563eb;
}
.news-time {
    color: #999;
    font-size: 13px;
    flex-shrink: 0;
}
.news-empty {
    padding: 12px 0;
}
.report-way {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 0;
}
.report-title {
    color: #10636f;
    margin-bottom: 8px;
    position: relative;
    font-size: 16px;
    font-weight: bold;
}
.report-title::before, .report-title::after {
    content: "";
    position: absolute;
    top: 49%;
    height: 1px;
    width: 6em;
    background-color: orange;
}
.report-title::before {
    right: 130%;
}
.report-title::after {
    left: 130%;
}
.report-value {
    font-size: 14px;
    color: #222;
    margin-bottom: 24px;
}
</style>
